import { render } from "./kpiFacade.vue?vue&type=template&id=a4c291f4"
import script from "./kpiFacade.vue?vue&type=script&lang=js"
export * from "./kpiFacade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__